import { TextField } from "@material-ui/core"
const FieldMain = (props) => {
    const {
        name,
        label,
        type = "text",
        formik,
        required = true,
        width = "90%"
    } = props
    return (
        <div style={{ margin: "0.5rem 0"}}>
            <TextField
                required={required}
                style={{ width: width }}
                id={`id-${name}`}
                label={`${label}`}
                type={type}
                variant="outlined"
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                error={formik.touched[name] && Boolean(formik.errors[name])}
                helperText={formik.touched[name] && formik.errors[name]}
            />
        </div>
    )
}
export default FieldMain